import { Button, ButtonText } from '@/ui/core/button'
import { Header } from '@/ui/core/header'
import { Screen } from '@/ui/core/screen'
import { HStack, VStack } from '@/ui/core/stack'
import { router } from 'expo-router'

const NotFoundScreen = () => {
	const returnHome = () => {
		router.push('/')
	}

	return (
		<HStack fullHeight>
			<Screen preset="fixed" className="flex flex-1">
				<VStack className="justify-center items-center h-full gap-8">
					<Header variant="h2">Page not found</Header>
					<Button onPress={returnHome}>
						<ButtonText>Go home</ButtonText>
					</Button>
				</VStack>
			</Screen>
		</HStack>
	)
}

export default NotFoundScreen
